import { EventEmitter } from "eventemitter3";
export class Synchronizer extends EventEmitter {
}
